<template>
  <div
    @click="changeMapType"
    class="baseLayerDiv cursorPointer"
  >
    <img
      :src="imageSource"
      class="mx-auto d-block p-2 image"
    >
    <button
      v-if="isValidMapType"
      class="btn btn-sm btn-block btn-secondary"
    >
      {{ buttonText }}
    </button>
    <span v-else>invalid map type</span>
  </div>
</template>

<script>
import EventBus from '@/eventBus';

const hybridImage = require('@/assets/icons//MapStyles_3_Hybrid_1024@0,25x@0,25x.png');
const vectorImage = require('@/assets/icons//MapStyles_2Vector_1024@0,25x@0,25x.png');

const mapTypes = ['vector', 'hybrid'];

export default {
  computed: {
    buttonText() {
      if (this.isVectorMapType) {
        return 'select hybrid';
      }
      if (this.isHybridMapType) {
        return 'select vector';
      }
      return '';
    },
    imageSource() {
      return this.isVectorMapType ? hybridImage : vectorImage;
    },
    isHybridMapType() {
      return this.normalisedSelectedMapType === mapTypes[1];
    },
    isValidMapType() {
      return this.isHybridMapType || this.isVectorMapType;
    },
    isVectorMapType() {
      return this.normalisedSelectedMapType === mapTypes[0];
    },
    normalisedSelectedMapType() {
      return this.selectedMapType.toLowerCase();
    },
  },
  data() {
    return {
      selectedMapType: this.currentMapType,
    };
  },
  methods: {
    changeMapType() {
      const index = mapTypes.indexOf(this.selectedMapType) === 0 ? 1 : 0;
      this.selectedMapType = mapTypes[index];
      EventBus.$emit('change-map-type', this.selectedMapType);
    },
  },
  name: 'MapBaseSelector',
  props: {
    currentMapType: {
      default: 'vector', // default here just prevents null ref error
      required: true,
      type: String,
      validator: (value) => mapTypes.some((mt) => value.toLowerCase() === mt),
    },
  },
  watch: {
    currentMapType(newV) {
      if (mapTypes.some((mt) => mt === newV.toLowerCase())) {
        this.selectedMapType = newV.toLowerCase();
      } else {
        [this.selectedMapType] = mapTypes;
      }
      EventBus.$emit('change-map-type', this.selectedMapType);
    },
  },
};
</script>

<style>
.pointer-events-all{
  pointer-events: all;
}

.baseLayerDiv {
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid #3a1831;
  box-sizing: content-box;
  width: 90px;
}

.image {
  width: 60px;
  height: 60px;
}

.cursorPointer {
  cursor: pointer;
}
</style>
